import React, { FC, memo } from 'react';
import {
  Container,
  Description,
  Description2Title,
  ImageContainer,
  Info,
  Link,
  Summary,
  SummaryTitle,
  Supertitle,
  SupertitleContainer,
  Tag,
  Title,
} from './styles';
import { Props } from './types';

const Benefit: FC<Props> = ({
  Icon,
  summaryTitle,
  summary,
  descriptionTitle,
  description,
  description2Title,
  description2,
  supertitle,
  title,
  link,
  linkText,
  tag,
  ...rest
}) => (
  <Container {...rest}>
    <Info>
      <SupertitleContainer>
        <Supertitle>{supertitle}</Supertitle>
        {tag ? <Tag>{tag}</Tag> : null}
      </SupertitleContainer>
      <Title>{title}</Title>
      {summaryTitle ? <SummaryTitle>{summaryTitle}</SummaryTitle> : null}
      <Summary>{summary}</Summary>
      <Description>{description}</Description>
      {description2Title ? (
        <Description2Title>{description2Title}</Description2Title>
      ) : null}
      {description2 ? <Description>{description2}</Description> : null}
      <Link to={link} text={linkText} target="_blank" />
    </Info>
    <ImageContainer>
      <Icon />
    </ImageContainer>
  </Container>
);

export default memo(Benefit);
